<!-- modal ver esc-->
<template>
  <div class="text-center">
    <v-dialog v-model="dialog" xmax-width="1100" persistent scrollable>
      <v-card class="ve-card">
        <v-card-title class="ve-hero py-3">
          <div class="d-flex align-center justify-space-between" style="width: 100%;">
            <div class="d-flex align-center" style="gap: 12px;">
              <v-avatar color="white" size="40" class="elevation-1">
                <v-icon color="teal darken-3">mdi-clipboard-check-outline</v-icon>
              </v-avatar>
              <div>
                <div class="text-h6 white--text">Programas Universidad escogidos</div>
                <div class="text-body-2 white--text">
                  Asigna la sede y confirma los programas aprobados
                </div>
              </div>
            </div>
            <v-chip color="teal lighten-5" class="teal--text text--darken-3" small>
              Registros: {{ filteredEscogidos?filteredEscogidos[0]?filteredEscogidos[0].seleccionados.length : 0 :0  }}
            </v-chip>
          </div>
        </v-card-title>

        <v-card-text class="pt-2">
          <v-divider class="mb-4" />
          <v-row dense class="mb-2">
            <v-col cols="12" sm="6" md="4">
              <v-select
                :items="xmeses"
                v-model="input.mes"
                label="Mes de oferta"
                item-value="id"
                item-text="text"
                dense
                outlined
                prepend-icon="mdi-calendar"
              />
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Año de oferta"
                v-model.number="input.anio"
                dense
                outlined
                prepend-icon="mdi-calendar"
                type="number"
              />
            </v-col>
          </v-row>

          <v-fade-transition v-if="loading">
            <div>
              <v-progress-linear indeterminate color="primary" class="mb-4" />
              <v-skeleton-loader type="table" class="mb-4" />
              <v-skeleton-loader type="table" />
            </div>
          </v-fade-transition>

          <v-fade-transition v-else>
            <div>
              <v-row v-if="filteredEscogidos.length === 0">
                <v-col cols="12">
                  <v-alert type="info" border="left" colored-border>
                    No hay registros para el mes seleccionado.
                  </v-alert>
                </v-col>
              </v-row>

              <v-row v-for="(e,ind) in filteredEscogidos" :key="ind" dense>
                <v-col cols="12">
                  <v-card outlined class="pa-3">
                    <div class="text-subtitle-2">
                      Oferta: {{ e.nombre_oferta }}
                    </div>
                    <div class="text-body-2 text--secondary">
                      Periodo: {{ mesTexto(e.mes) }} · {{ e.anio }}
                    </div>
                  </v-card>
                </v-col>
                <v-col cols="12">
                  <v-data-table
                    :headers="xheaders_punis"
                    :items="e.seleccionados"
                    disable-pagination
                    hide-default-footer
                    dense
                    class="elevation-1"
                    no-data-text="No hay programas en esta oferta"
                  >
                    <template v-slot:[`item.sede`]="{ item }">
                      <v-autocomplete
                        v-model="item.sede"
                        :items="xsedes"
                        item-value="id"
                        item-text="nombre"
                        :return-object="true"
                        dense
                        outlined
                        clearable
                        hide-details
                        placeholder="Seleccione la sede..."
                        style="min-width: 220px; max-width: 260px;"
                        class="my-1"
                      />
                    </template>
                    <template v-slot:[`item.fecha_inicio_campana`]="{ item }">
                      <v-text-field v-model.trim="item.fecha_inicio_campana" type="date" dense outlined hide-details  />
                    </template>
                    <template v-slot:item.programaNombre="{ item }">
                      <div>
                        <div>{{ item.programaNombre }}</div>
                        <div class="caption grey--text">{{ item.areaUniversidad ? item.areaUniversidad.nombre : '' }}</div>
                      </div>
                    </template>
                    <template v-slot:item.ceubArchivoId="{ item }">
                      <v-chip x-small :color="item.ceubArchivoId ? 'teal darken-2' : 'grey lighten-1'" :dark="!!item.ceubArchivoId">
                        {{ item.ceubArchivoId ? 'si' : 'no' }}
                      </v-chip>
                    </template>
                    <template v-slot:item.programas="{ item }">
                      <v-chip x-small color="teal lighten-5" class="teal--text text--darken-3" @click="$refs.refmodalVerProgs_esam.openmodal(item)">
                        {{ item.programas ? item.programas.length : 0 }}
                      </v-chip>
                    </template>
                    <template v-slot:item.creacion_esam="{ item }">
                      <v-chip
                        v-if="item._programa_esam_creado"
                        x-small
                        color="green darken-2"
                        dark
                        :title="item._programa_esam_nombre_compuesto || ''"
                      >
                        ID #{{ item._programa_esam_id || 'creado' }}
                      </v-chip>
                      <v-chip v-else x-small color="grey lighten-3" class="grey--text text--darken-2">
                        pendiente
                      </v-chip>
                    </template>
                    <template v-slot:item.estado="{ item }">
                      <v-chip x-small :color="item.estado === 'inscrito' ? 'green' : 'orange'" dark>
                        {{ item.estado }}
                      </v-chip>
                    </template>
                  </v-data-table>
                </v-col>
                <v-col cols="12" class="d-flex justify-end">
                  <v-btn color="teal darken-2" class="white--text" :loading="loading_aprob" @click="aprobar_seleccion(e)">
                    <v-icon left small>mdi-check-circle</v-icon>
                    Confirmar y Crear Programas
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </v-fade-transition>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- <v-btn color="green" :loading="loading" outlined @click="enviar()"> Guardar seleccion </v-btn> -->
          <v-btn color="grey" text @click="cerrar()">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <modalVerResumen ref="refmodalVerResumen" @cerrar="cerrar" />
    <modalVerProgs_esam ref="refmodalVerProgs_esam" />
  </div>
</template>

<script> 
import modalVerProgs_esam from './modal-ver-progs_esam.vue';
import modalVerResumen from './modal-ver_resumen.vue';
import {headers_punis2, meses} from './utils';
import gql from 'graphql-tag'
import { crearProgramasEsamMasivo } from '@/views/programa_reg_from_oferta/crear-programa-esam';

const CREAR_PROGRAMAS_ESAM_AUTOMATICO = true;

  export default {
    components:{modalVerProgs_esam, modalVerResumen},
    data() {
      return {
        loading: true, 
        loading_aprob: false, 
        dialog: false,    
        xheaders_punis: [],
        xmeses: [],
        xsedes: [],
        escogidos: [],
        filteredEscogidos: [],
        input:{
            nombre_oferta:'',
            mes: new Date().getMonth(),
            anio: new Date().getFullYear(),
        }
      };
    }, 
    watch:{
      'input.mes': function() {
        this.listar()
      },
      'input.anio': function() {
        this.listar()
      }
    },
    methods: {
      async openmodal() {  
        this.dialog = true; 
        this.input.nombre_oferta = '';
        this.input.mes = new Date().getMonth();
        this.input.anio = new Date().getFullYear(); 
        this.xheaders_punis = headers_punis2();
        if (!this.xheaders_punis.find(h => h.value === 'creacion_esam')) {
          const indexProgramas = this.xheaders_punis.findIndex(h => h.value === 'programas');
          this.xheaders_punis.splice(indexProgramas + 1, 0, { text: 'Programa ESAM', value: 'creacion_esam', sortable: false });
        }
        this.xmeses = meses();
        this.escogidos = []

        this.loading = true;
        await this.getSedes()
        this.listar()
      }, 
      mesTexto(mesId) {
        const m = this.xmeses.find(x => x.id === mesId);
        return m ? m.text : mesId;
      },
      cerrar() {
        this.dialog = false;
      }, 
      async guardarRespuestaCreacionMasiva(row, reporte) {
        const datos = {
          id_escogidos: row.id,
          response: JSON.stringify(reporte),
        };
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        const graphql = JSON.stringify({
          query: "mutation save_aprobado_reponses($input:NewAprobadosResponse!){ save_aprobado_reponses(input:$input){id seleccionados_por nombre_oferta mes anio} }",
          variables: { input: datos }
        });
        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: graphql,
        };

        return await fetch(process.env.VUE_APP_PROYECTOS_API, requestOptions)
          .then(r=>r.json())
          .then(({data})=>data)
          .catch(e=>e);
      },
      async getSedes() {
        const qs = gql` query {getSedes ${''} {id,nombre,unidad_negocio}}`;
        const res = await this.$apollo.query({ query: qs }).then(({ data }) => data).catch(e => e);
        if(res && res.getSedes){
          this.xsedes = res.getSedes;
        }
      },
      parseJsonSeguro(value) {
        if (!value) return null;
        if (typeof value === 'object') return value;
        try {
          return JSON.parse(value);
        } catch (e) {
          return null;
        }
      },
      marcarProgramasEsamCreados(escogido) {
        const reporte = this.parseJsonSeguro(escogido.aprobados_response_create);
        const creados = [
          ...(reporte?.creados || []),
          ...(reporte?.omitidos || []),
        ];
        const creadosMap = new Map();
        creados.forEach(item => {
          if (item.programa_universidad_id) creadosMap.set(Number(item.programa_universidad_id), item);
        });
        escogido.seleccionados.forEach(s => {
          const creado = creadosMap.get(Number(s.id));
          s._programa_esam_creado = !!creado;
          s._programa_esam_id = creado?.programa_id || null;
          s._programa_esam_nombre_compuesto = creado?.nombre_compuesto || '';
        });
      },
      async listar() {
        this.loading = true;
        const q = {
          mes: this.input.mes,
          anio: this.input.anio,
        }
        
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        const graphql = JSON.stringify({
          query: "query escogidos($q:QueryEscogidos!){ escogidos(q:$q){id seleccionados_por nombre_oferta mes anio seleccionados aprobados aprobados_response_create fecha_registro} }",
          variables: {q:q}
        })
        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: graphql, 
        };

        const res = await fetch(process.env.VUE_APP_PROYECTOS_API, requestOptions).then(r=>r.json()).then(({data})=>data).catch(e=>e)
        
        // window.console.log('res',res);
        if(res && res.escogidos){
            res.escogidos.map(e=>{
                e.seleccionados = JSON.parse(e.seleccionados);
                e.aprobados = JSON.parse(e.aprobados); 
                if(!e.aprobados) e.aprobados = []
                e.aprobados.forEach(a=>{ 
                  const sel = e.seleccionados.find(s=>s.programaNombre==a.programaNombre);
                  if(sel){
                    sel.sede = a.sede;
                    sel.fecha_inicio_campana = a.fecha_inicio_campana
                  }
                })
                this.marcarProgramasEsamCreados(e);
                return e;
            })
            this.escogidos = res.escogidos;
            this.filteredEscogidos = res.escogidos;
        }
        this.loading = false;
      },

      async aprobar_seleccion(row){
        window.console.log('aprobar',row);

        let msg = '';
        const xaprobar = []; 
        row.seleccionados.forEach(s=>{  
          if(s.sede){
            xaprobar.push(s)
          }
          if((s.sede && !s.fecha_inicio_campana) || (!s.sede && s.fecha_inicio_campana)){
            msg = 'debe seleccionar la sede y fecha de campana para: '+s.programaNombre
          }
        })  

        
        if(msg) {
          this.$root.$notify.show(msg, { color: 'red', x: 'right' });
          return;
        }
        this.loading_aprob = true;
        const datos = {
          id_escogidos: row.id,
          aprobados: JSON.stringify(xaprobar),
        }

        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        const graphql = JSON.stringify({
          query: "mutation save_aprobados($input:NewAprobados!){ save_aprobados(input:$input){id aprobados fecha_registro} }",
          variables: { "input":datos }
        })
        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: graphql, 
        };

        const res = await fetch(process.env.VUE_APP_PROYECTOS_API, requestOptions).then(r=>r.json()).then(({data})=>data).catch(e=>e)
        window.console.log('res',res);
        if(res && res.save_aprobados){
          /* this.$root.$notify.show('Seleccion guardada', {
            color: 'green',
            x: 'right',
          }); */ 

          if (CREAR_PROGRAMAS_ESAM_AUTOMATICO) {
            const resultado = await crearProgramasEsamMasivo(this, xaprobar, {
              aprobadosResponseCreate: row.aprobados_response_create,
            });
            const guardado = await this.guardarRespuestaCreacionMasiva(row, resultado.reporte);
            if (!guardado || !guardado.save_aprobado_reponses) {
              this.$root.$notify.show('No se pudo guardar el reporte de creación masiva', {
                color: 'red',
                x: 'right',
                timeout: 12000,
              });
            } else {
              row.aprobados_response_create = JSON.stringify(resultado.reporte);
              this.marcarProgramasEsamCreados(row);
            }

            this.$refs.refmodalVerResumen.openmodal(resultado.reporte);
            this.loading_aprob = false;
            this.$root.$notify.show(`Creación masiva finalizada. Creados: ${resultado.reporte.total_creados}, fallidos: ${resultado.reporte.total_fallidos}`, {
              color: resultado.reporte.total_fallidos ? 'orange' : 'green',
              x: 'right',
              timeout: 12000,
            });
            return;
          }

          this.loading_aprob = false;
          this.cerrar()
          return;
        }
        this.loading_aprob = false;
      }
    },
  };
</script>

<style scoped>
.ve-card {
  border-radius: 14px;
  overflow: hidden;
}
.ve-hero {
  background: linear-gradient(120deg, #004D40 0%, #00796B 45%, #4DB6AC 100%);
}
</style>
